import { FunctionComponent } from 'react'
import styled from 'styled-components'
import Card from '@/components/billboard/top100/content/top-list/card'
import {
  AnalyzeRankingItem,
  RankingPlatformType,
} from '@/types/schema/k6/analyze-api'

interface TopListProps {
  className?: string
  platform: RankingPlatformType
  top3List: [AnalyzeRankingItem, AnalyzeRankingItem, AnalyzeRankingItem]
}

const TopList: FunctionComponent<TopListProps> = ({
  className,
  platform,
  top3List,
}) => {
  return (
    <Wrapper className={className}>
      {top3List.map((item) => (
        <Card analyzeRankingItem={item} key={item.uuid} platform={platform} />
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
  }

  ${Card} {
    width: 1px;
    flex: 1;

    @media (max-width: 768px) {
      width: 100%;
    }

    & + ${Card} {
      margin-left: 16px;

      @media (max-width: 768px) {
        margin-left: 0;
        margin-top: 24px;
      }
    }
  }
`

export default styled(TopList)``
